import React from 'react'
import { Grid, Container, Box, useMediaQuery } from '@material-ui/core'
import { LoadingFeedback, Page } from 'components'
import { Text } from 'views/UserSteps/components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'

import useStyles from './styles'
import helpers from 'helpers'
import theme from 'theme'

const ConsultPolicy = ({ match }) => {
  const { token } = match.params
  const classes = useStyles()

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  })

  const { response, isLoading } = useFetch(
    service.dponet.privacyPolicies.certificate,
    {
      token,
    },
    [],
    !!token,
  )

  const privacyPolicy = response?.data?.privacyPolicy

  return (
    <Page title="Consultar certificação" transparent noPadding>
      <Container maxWidth="lg" className={classes.container}>
        <LoadingFeedback open={isLoading} />
        <Grid container className={classes.gridContainer} alignItems="stretch">
          <Grid item sm={12} md={6} lg={5}>
            <Box className={classes.imgBox} />
          </Grid>
          <Grid item sm={12} md={6} lg={7}>
            <Box className={classes.dataBox}>
              <Box className={classes.boxCertificate} mt={4}>
                <Text fontSize={35} variant="h2">
                  Este documento é válido
                </Text>
                <Text fontSize={16} variant="subtitle1">
                  {privacyPolicy?.company?.name}
                </Text>
                <Text fontSize={16} variant="subtitle1">
                  CNPJ/CPF: {privacyPolicy?.company?.document}
                </Text>
                <Text fontSize={16} variant="subtitle1">
                  Publicado em:{' '}
                  {helpers.formatters.date(privacyPolicy?.createdAt)}
                </Text>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default ConsultPolicy
